var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.22222C1 8.03934 1.16094 8.84845 1.47364 9.60336C1.78633 10.3583 2.24466 11.0442 2.82245 11.622C3.40023 12.1998 4.08617 12.6581 4.84108 12.9708C5.596 13.2835 6.40511 13.4444 7.22222 13.4444C8.03934 13.4444 8.84845 13.2835 9.60336 12.9708C10.3583 12.6581 11.0442 12.1998 11.622 11.622C12.1998 11.0442 12.6581 10.3583 12.9708 9.60336C13.2835 8.84845 13.4444 8.03934 13.4444 7.22222C13.4444 6.40511 13.2835 5.596 12.9708 4.84108C12.6581 4.08617 12.1998 3.40023 11.622 2.82245C11.0442 2.24466 10.3583 1.78633 9.60336 1.47364C8.84845 1.16094 8.03934 1 7.22222 1C6.40511 1 5.596 1.16094 4.84108 1.47364C4.08617 1.78633 3.40023 2.24466 2.82245 2.82245C2.24466 3.40023 1.78633 4.08617 1.47364 4.84108C1.16094 5.596 1 6.40511 1 7.22222Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55554 7.22266H9.88888",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22217 4.55664V9.88997",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9993L11.6666 11.666",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.09972e7547abbb6a50844c7fa5467c14.svg";
export { ForwardRef as ReactComponent };